"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationResultDisplay = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _emotion = require("emotion");

var _commonStyles = require("../commonStyles");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ValidationResultMessage = function ValidationResultMessage(_ref) {
  var result = _ref.result;
  return (
    /*#__PURE__*/
    _react["default"].createElement("li", null,
    /*#__PURE__*/
    _react["default"].createElement(_reactIntl.FormattedMessage, _extends({}, _messages["default"][result.id], {
      values: _objectSpread(_objectSpread({}, result.values), {}, {
        intro: function intro() {
          for (var _len = arguments.length, msg = new Array(_len), _key = 0; _key < _len; _key++) {
            msg[_key] = arguments[_key];
          }

          return (
            /*#__PURE__*/
            _react["default"].createElement("span", null, msg)
          );
        },
        list: function list() {
          for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            msg[_key2] = arguments[_key2];
          }

          return (
            /*#__PURE__*/
            _react["default"].createElement("ul", null, msg)
          );
        },
        listitem: function listitem() {
          for (var _len3 = arguments.length, msg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            msg[_key3] = arguments[_key3];
          }

          return (
            /*#__PURE__*/
            _react["default"].createElement("li", {
              key: msg
            }, msg)
          );
        }
      })
    })))
  );
};

var ValidationResultDisplay = function ValidationResultDisplay(_ref2) {
  var errors = _ref2.errors,
      warnings = _ref2.warnings;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null, errors && errors.length > 0 ?
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)(_commonStyles.tenPxMarginBottom, 'text-danger')
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactIntl.FormattedMessage, _messages["default"].errorValidatingInput),
    /*#__PURE__*/
    _react["default"].createElement("ul", null, errors.map(function (error) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(ValidationResultMessage, {
          key: JSON.stringify(error),
          result: error
        })
      );
    }))) : null, warnings && warnings.length > 0 ?
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)(_commonStyles.tenPxMarginBottom, 'text-warning')
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactIntl.FormattedMessage, _messages["default"].warningValidatingInput),
    /*#__PURE__*/
    _react["default"].createElement("ul", null, warnings.map(function (warning) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(ValidationResultMessage, {
          key: JSON.stringify(warning),
          result: warning
        })
      );
    }))) : null)
  );
};

exports.ValidationResultDisplay = ValidationResultDisplay;

var resultsPropType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].object
}));

ValidationResultDisplay.propTypes = {
  errors: resultsPropType,
  warnings: resultsPropType
};